<template>
  <b-card class="shadow-sm">
    <b-card-body>
      <b-card-title class="mb-2 pl-6 pr-6 pt-6">
        <div class="d-flex align-items-center">
          <b-icon icon="currency-dollar" variant="primary" class="mr-2" />
          <b-dropdown
            variant="link"
            toggle-class="p-0 text-secondary font-weight-bold dashboard-title-dropdown"
            menu-class="dashboard-title-menu"
            no-caret
          >
            <template #button-content>
              <span>{{ indicadorSelecionadoLabel }}</span>
              <b-icon icon="chevron-down" class="ml-2" />
            </template>
            <b-dropdown-item
              :active="indicadorSelecionado === 'margem'"
              @click="indicadorSelecionado = 'margem'"
            >
              Margem de lucro
            </b-dropdown-item>
            <b-dropdown-item
              :active="indicadorSelecionado === 'lucro'"
              @click="indicadorSelecionado = 'lucro'"
            >
              Lucro
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <!-- Filtro de período -->
        <FiltroPeriodo
          class="mt-4"
          :value="periodo"
          default-label="Hoje"
          :auto-apply-on-mount="!ignoreInitialApply"
          @apply="onApplyPeriodo"
        />
      </b-card-title>

      <div class="pl-6 pb-4">
        <!-- LOADING -->
        <div v-if="loading" class="display-4">
          <b-skeleton width="40%" height="36px" />
        </div>

        <!-- CONTEÚDO -->
        <div v-else>
          <h2 class="display-4 text-primary mb-0 font-weight-bold">
            {{
              indicadorSelecionado === "margem"
                ? formatPercent(margemNumber)
                : formatCurrency(lucroNumber)
            }}
          </h2>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "MargemLucro",
  components: { FiltroPeriodo },
  props: {
    // objeto da margem (ex.: { margemPercent: 40, lucro: 100 })
    margemLucro: { type: [Object, Number, String], default: () => ({}) },

    // período atual (opcional): { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' } ou null
    periodo: { type: Object, default: null },

    // estado de carregamento
    loading: { type: Boolean, default: false },

    // se true, NÃO dispara apply no mount do filtro (mantém quieto no boot)
    ignoreInitialApply: { type: Boolean, default: true },

    // opcional: mensagem de erro (se quiser exibir algo custom)
    error: { type: String, default: null },
  },
  data() {
    return {
      indicadorSelecionado: "margem",
    };
  },
  computed: {
    indicadorSelecionadoLabel() {
      return this.indicadorSelecionado === "margem"
        ? "Margem de lucro"
        : "Lucro";
    },
    margemNumber() {
      return this.toNumber(
        this.margemLucro?.margemPercent ??
          this.margemLucro?.margemPercentual ??
          this.margemLucro?.percentualLucro ??
          this.margemLucro?.percentual_lucro ??
          this.margemLucro?.margemLucro ??
          this.margemLucro?.margem_lucro ??
          this.margemLucro?.margem ??
          this.margemLucro ??
          0
      );
    },
    lucroNumber() {
      return this.toNumber(
        this.margemLucro?.lucro ??
          this.margemLucro?.lucroTotal ??
          this.margemLucro?.lucro_total ??
          this.margemLucro?.valorLucro ??
          this.margemLucro?.valor_lucro ??
          this.margemLucro?.totalLucro ??
          this.margemLucro?.total_lucro ??
          this.margemLucro?.lucroReais ??
          this.margemLucro?.lucro_reais ??
          0
      );
    },
  },
  methods: {
    onApplyPeriodo({ inicio, fim }) {
      // repassa para o pai exatamente como o TicketMedio faz
      this.$emit("change-periodo", { inicio, fim });
    },
    toNumber(value) {
      if (value === null || value === undefined || value === "") return 0;

      if (typeof value === "string") {
        const normalized = value.includes(",")
          ? value.replace(/\./g, "").replace(",", ".")
          : value;
        const n = Number(normalized);
        return Number.isFinite(n) ? n : 0;
      }

      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    },
    formatPercent(v) {
      if (v === null || v === undefined || v === "") return "0%";
      return `${String(v).replace(".", ",")}%`;
    },
    formatCurrency(v) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(v ?? 0);
      } catch {
        const num = Number(v ?? 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },
  },
};
</script>

<style scoped>
.display-4 {
  line-height: 1.1;
}

::v-deep .dashboard-title-dropdown {
  color: #6c7293 !important;
  font-size: inherit;
  line-height: inherit;
  text-decoration: none !important;
  vertical-align: baseline;
}

::v-deep .dashboard-title-dropdown:hover,
::v-deep .dashboard-title-dropdown:focus {
  color: #f36f61 !important;
  text-decoration: none !important;
  box-shadow: none;
}

::v-deep .dashboard-title-menu .dropdown-item.active {
  background-color: #f36f61;
}
</style>
